<template>
    <tbody>
        <tr v-bind:class="rowClass">
          <td>
            <figure><svg-icon :icon="rowIcon"
                    :size="19"
                    :addClass="'top-agents'"></svg-icon></figure>
            <span class="ut-font-bold">{{ rowName }}</span>
          </td>
          <td>{{ referrals }}</td>
          <td>{{ listingReferrals }}</td>
          <td>{{ yourListings }}</td>
          <td>{{ wonListings }}</td>
          <td>{{ firstAttempt }}</td>
          <td>{{ contact }}</td>
          <td>{{ SuccessfulContact }}</td>
        </tr>
        <slot></slot>
    </tbody>
</template>

<script>
import Avatar from '@/components/Avatar.vue';
import SvgIcon from '@/components/SvgIcon.vue';

export default {
  name: 'PerformanceOverview',
  components: {
    Avatar,
    SvgIcon,
  },
  props: {
    rowClass: {
      type: String, // top-agents or group-overview
      require: false,
    },
    rowName: {
      type: String, // top-agents or group-overview
      require: true,
    },
    rowIcon: {
      type: String, // top-agents or group-overview
      require: true,
    },
    referrals: {
      default: '-',
    },
    listingReferrals: {
      default: '-',
    },
    yourListings: {
      default: '-',
    },
    wonListings: {
      default: '-',
    },
    firstAttempt: {
      default: '-',
    },
    contact: {
      default: '-',
    },
    SuccessfulContact: {
      default: '-',
    },

  },
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    tr {
        border-top: 1px solid rgba(151, 151, 151, 0.4);
        background-color: #ffffff;
        color: #233A3A;

        td {
            @apply ut-text-center ut-py-4 ut-px-2;
            width: 10.5%;
            font-size: 14px;
            line-height: 18px;

            &:first-child {
                @apply ut-text-left ut-pl-4 capitalize;
                width: 26.5%;
                font-weight: 700;

                @screen xl {
                    @apply ut-pl-16;
                }
            }

            &:last-child {
                @apply ut-pr-4;
            }

            figure {
                @apply ut-inline-block ut-mr-4 ut-align-middle ut-overflow-hidden ut-rounded-full;
                box-shadow: 0 0 0 1px rgba(36,33,25,0.1);
                height: 34px;
                width: 34px;
            }

        }

        &.group-overview, &.top-agents {
            border-top: 1px solid rgba(151, 151, 151, 1);

            td {

                &:first-child {
                    @apply ut-pl-4;
                }

                figure {
                    @apply ut-mr-1 ut-overflow-auto;
                    box-shadow: none;
                    height: auto;
                    width: auto;
                }
            }

        }

        &.group-overview {
            border-bottom: 1px solid rgba(151, 151, 151, 1);
            background-color: #F7F5F3;
            font-weight: 700;
        }

        &.top-agents {
            background-color: #ffffff;
            @apply ut-text-green-400;
        }
    }
</style>
